import { Injectable, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from './modal/confirmation/confirmation-modal.component';
import { YesNoConfirmationModalComponent } from './modal/yesnoconfirmation/yesnoconfirmation-modal.component';

@Injectable({
    providedIn: 'root'
})
export class Ng2ConfirmationService {

    YesNoQuestion: any;
    YesNoCancelQuestion: any;

    constructor(private ngbModal: NgbModal) { 

        var self = this;

        this.YesNoQuestion = function (message, data) {
            this.messageText = message;
            this.data = data;
            return this;
        }
        this.YesNoCancelQuestion = function (message, data) {
            self.YesNoQuestion.call(this, message, data);
            return this;
        }
        this.YesNoQuestion.prototype.No = function (action) {
            this.noAction = action;
            return this;
        };
        this.YesNoQuestion.prototype.Yes = function (action) {
            this.yesAction = action;
            return this;
        };
        this.YesNoQuestion.prototype.Ask = function (args) {

            let options = {
                backdrop: 'static' as 'static'
            };

            var modal = self.ngbModal.open(YesNoConfirmationModalComponent, args);
            modal.componentInstance.message = this.messageText;
            modal.componentInstance.data = this.data;

            var noAction = this.noAction;
            var yesAction = this.yesAction;

            modal.result.then(function (leave) {
                if (leave === 'no' && noAction) {
                    noAction();
                }

                if (leave === 'yes' && yesAction) {
                    yesAction();
                }

                modal.dismiss();
            });
        };
        this.YesNoCancelQuestion.prototype = Object.create(this.YesNoQuestion.prototype);
        this.YesNoCancelQuestion.prototype.constructor = this.YesNoCancelQuestion;
        this.YesNoCancelQuestion.prototype.Cancel = function (action) {
            this.cancelAction = action;
            return this;
        };
        this.YesNoCancelQuestion.prototype.Ask = function (args?: NgbModalOptions) {
            let options = {
                backdrop: 'static' as 'static'
            };
            options = Object.assign(options, args);

            let modal = self.ngbModal.open(ConfirmationModalComponent, options);
            modal.componentInstance.message = this.messageText;
            modal.componentInstance.data = this.data;

            var noAction = this.noAction;
            var yesAction = this.yesAction;
            var cancelAction = this.cancelAction;
            
            modal.result.then(function (leave) {
                if (leave === 'no' && noAction) {
                    noAction();
                }

                if (leave === 'yes' && yesAction) {
                    yesAction();
                }

                if (!leave && cancelAction) {
                    cancelAction();
                }

                modal.dismiss();
            });
        };
    }


    YesNoConfirmation = (message, data) => {
        return new this.YesNoQuestion(message, data);
    }

    Confirmation = (message, data) => {
        return new this.YesNoCancelQuestion(message, data);
    }
}
